import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Modal, Text, Theme } from '@simplybenefits/sb-ui-library';
import * as dates from '@simplybenefits/sb-dates';
import PhotoGrid from '../../CreateClaim/Common/PhotoGrid.js';
import pdfImg from '../../../../assets/pdf.png';

class ReviewClaimModal extends PureComponent {
    render() {
        const { submitClaim, type } = this.props;
        const styles = {
            metaBlock: {
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: 'row',
                paddingBottom: 2
            },
            block: {
                paddingBottom: 10
            },
            receiptPhoto: {
                height: 'auto',
                width: '40%',
                alignSelf: 'center',
                backgroundColor: 'transparent',
                marginTop: 10,
                display: 'block',
                margin: 'auto'
            }
        };

        return (
            <Modal
                medium
                testid="submit-claim-modal"
                aria-labelledby="Submit Claim"
                open={true}
                title={ this.props.title }
                primaryButton={{
                    label: "Submit",
                    onClick: submitClaim
                }}
                onClose={ this.props.onClose}
                loader={ this.props.loader }
                onBack={ this.props.onBack }
            >
                <div style={styles.metaBlock}>
                    <Text
                        light
                        medium
                        flex={1}
                    >
                            Certificate:
                    </Text>

                    <Text medium>{ this.props.meta.cert }</Text>
                </div>

                <div style={styles.metaBlock}>
                    <Text
                        light
                        medium
                        flex={1}
                    >
                            Patient:
                    </Text>

                    <Text medium>{ this.props.meta.patient.name }</Text>
                </div>

                <div style={styles.metaBlock}>
                    <Text
                        light
                        medium
                        flex={1}
                    >
                            Dentist:
                    </Text>

                    <Text medium>{ this.props.meta.dentist }</Text>
                </div>

                <div style={styles.metaBlock}>
                    <Text
                        light
                        medium
                        flex={1}
                    >
                            Office Postal Code:
                    </Text>

                    <Text medium>{ this.props.meta.officePostalCode }</Text>
                </div>

                {
                    (this.props.meta.payee && this.props.meta.payee.length > 0) &&
                            <div style={styles.metaBlock}>
                                <Text
                                    light
                                    medium
                                    flex={1}
                                >
                                    Payee:
                                </Text>

                                <Text medium>{ this.props.meta.payee }</Text>
                            </div>
                }

                {
                    this.props.isCOB &&
                            <>
                                <div style={styles.metaBlock}>
                                    <Text
                                        light
                                        medium
                                        flex={1}
                                    >
                                        Total Amount of Service:
                                    </Text>

                                    <Text medium>${ this.props.meta.totalAmountOfService }</Text>
                                </div>

                                <div style={styles.metaBlock}>
                                    <Text
                                        light
                                        medium
                                        flex={1}
                                    >
                                        Total Benefit Amount:
                                    </Text>

                                    <Text medium>${ this.props.meta.totalBenefitAmount }</Text>
                                </div>

                                <div style={styles.metaBlock}>
                                    <Text
                                        light
                                        medium
                                        flex={1}
                                    >
                                        Total Deductible Amount:
                                    </Text>

                                    <Text medium>${ this.props.meta.deductibleAmount }</Text>
                                </div>

                                <div style={styles.metaBlock}>
                                    <Text
                                        light
                                        medium
                                        flex={1}
                                    >
                                        Total Payable Amount:
                                    </Text>

                                    <Text medium>${ this.props.meta.totalPayable }</Text>
                                </div>
                            </>
                }

                {
                    this.props.eobProcedures && this.props.eobProcedures.map((procedure, i) => (
                        <div style={{ margin: "10px 0" }} >
                            <Text bold medium color={ Theme.colors.skyBlue } margin="10px 0">
                                    EOB Procedure { i + 1 }
                            </Text>

                            <div style={styles.metaBlock}>
                                <Text
                                    light
                                    medium
                                    flex={1}
                                >
                                    Eligible Amount:
                                </Text>

                                <Text medium>${ procedure.eligibleAmount }</Text>
                            </div>

                            <div style={styles.metaBlock}>
                                <Text
                                    light
                                    medium
                                    flex={1}
                                >
                                    Deductible Amount:
                                </Text>

                                <Text medium>${ procedure.deductibleAmount }</Text>
                            </div>

                            <div style={styles.metaBlock}>
                                <Text
                                    light
                                    medium
                                    flex={1}
                                >
                                    Eligible Percentage:
                                </Text>

                                <Text medium>{ procedure.eligiblePercentage }%</Text>
                            </div>

                            <div style={styles.metaBlock}>
                                <Text
                                    light
                                    medium
                                    flex={1}
                                >
                                    Benefit Amount:
                                </Text>

                                <Text medium>${ procedure.benefitAmountForProcedure }</Text>
                            </div>

                            {
                                (procedure.labProcedure1EligibleAmount && procedure.labProcedure1EligibleAmount.length > 0) &&
                                    <div style={styles.metaBlock}>
                                        <Text
                                            light
                                            medium
                                            flex={1}
                                        >
                                            Lab Procedure 1 Eligible Amount:
                                        </Text>

                                        <Text medium>${ procedure.labProcedure1EligibleAmount }</Text>
                                    </div>
                            }

                            {
                                (procedure.labProcedure1DeductibleAmount && procedure.labProcedure1DeductibleAmount.length > 0) &&
                                    <div style={styles.metaBlock}>
                                        <Text
                                            light
                                            medium
                                            flex={1}
                                        >
                                            Lab Procedure 1 Deductible Amount:
                                        </Text>

                                        <Text medium>${ procedure.labProcedure1DeductibleAmount }</Text>
                                    </div>
                            }

                            {
                                Boolean(procedure.labProcedure1EligiblePercentage && procedure.labProcedure1EligiblePercentage.length > 0) &&
                                    <div style={styles.metaBlock}>
                                        <Text
                                            light
                                            medium
                                            flex={1}
                                        >
                                            Lab Procedure 1 Eligible Percentage:
                                        </Text>

                                        <Text medium>{ procedure.labProcedure1EligiblePercentage }%</Text>
                                    </div>
                            }

                            {
                                Boolean(procedure.labProcedure1BenefitAmount && procedure.labProcedure1BenefitAmount.length > 0) &&
                                    <div style={styles.metaBlock}>
                                        <Text
                                            light
                                            medium
                                            flex={1}
                                        >
                                            Lab Procedure 1 Benefit Amount:
                                        </Text>

                                        <Text medium>${ procedure.labProcedure1BenefitAmount }</Text>
                                    </div>
                            }

                            {
                                Boolean(procedure.labProcedure2EligibleAmount && procedure.labProcedure2EligibleAmount.length > 0) &&
                                    <div style={styles.metaBlock}>
                                        <Text
                                            light
                                            medium
                                            flex={1}
                                        >
                                            Lab Procedure 2 Eligible Amount:
                                        </Text>

                                        <Text medium>${ procedure.labProcedure2EligibleAmount }</Text>
                                    </div>
                            }

                            {
                                Boolean(procedure.labProcedure2DeductibleAmount && procedure.labProcedure2DeductibleAmount.length > 0) &&
                                    <div style={styles.metaBlock}>
                                        <Text
                                            light
                                            medium
                                            flex={1}
                                        >
                                            Lab Procedure 2 Deductible Amount:
                                        </Text>

                                        <Text medium>${ procedure.labProcedure2DeductibleAmount }</Text>
                                    </div>
                            }

                            {
                                Boolean(procedure.labProcedure2EligiblePercentage && procedure.labProcedure2EligiblePercentage.length > 0) &&
                                    <div style={styles.metaBlock}>
                                        <Text
                                            light
                                            medium
                                            flex={1}
                                        >
                                            Lab Procedure 2 Eligible Percentage:
                                        </Text>

                                        <Text medium>{ procedure.labProcedure2EligiblePercentage }%</Text>
                                    </div>
                            }

                            {
                                Boolean(procedure.labProcedure2BenefitAmount && procedure.labProcedure2BenefitAmount.length > 0) &&
                                    <div style={styles.metaBlock}>
                                        <Text
                                            light
                                            medium
                                            flex={1}
                                        >
                                            Lab Procedure 2 Benefit Amount:
                                        </Text>

                                        <Text medium>${ procedure.labProcedure2BenefitAmount }</Text>
                                    </div>
                            }

                            {
                                Boolean(procedure.note1 && procedure.note1.length > 0) &&
                                    <div style={styles.metaBlock}>
                                        <Text
                                            light
                                            medium
                                            flex={1}
                                        >
                                            Note Line 1:
                                        </Text>

                                        <Text medium>{ procedure.note1 }</Text>
                                    </div>
                            }

                            {
                                Boolean(procedure.note2 && procedure.note2.length > 0) &&
                                    <div style={styles.metaBlock}>
                                        <Text
                                            light
                                            medium
                                            flex={1}
                                        >
                                            Note Line 2:
                                        </Text>

                                        <Text medium>{ procedure.note2 }</Text>
                                    </div>
                            }
                        </div>
                    ))
                }

                {
                    this.props.procedures.map((procedure, i) => (
                        <div style={{ margin: "10px 0" }} >
                            <Text bold medium color={ Theme.colors.skyBlue } margin="10px 0">
                                    Procedure { i + 1 }
                            </Text>

                            <div style={styles.metaBlock}>
                                <Text
                                    light
                                    medium
                                    flex={1}
                                >
                                        Procedure Code:
                                </Text>

                                <Text medium>{ procedure.code }</Text>
                            </div>

                            {
                                (procedure.serviceDate && procedure.serviceDate.length > 0) &&
                                        <div style={styles.metaBlock}>
                                            <Text
                                                light
                                                medium
                                                flex={1}
                                            >
                                                Service Date:
                                            </Text>

                                            <Text medium>{ dates.getLocalDisplay(procedure.serviceDate) }</Text>
                                        </div>
                            }

                            <div style={styles.metaBlock}>
                                <Text
                                    light
                                    medium
                                    flex={1}
                                >
                                        Tooth Number:
                                </Text>

                                <Text medium>{ procedure.toothNumber }</Text>
                            </div>

                            <div style={styles.metaBlock}>
                                <Text
                                    light
                                    medium
                                    flex={1}
                                >
                                        Tooth Surface:
                                </Text>

                                <Text medium>{ procedure.toothSurface }</Text>
                            </div>

                            <div style={styles.metaBlock}>
                                <Text
                                    light
                                    medium
                                    flex={1}
                                >
                                        Dentist Fee Claimed:
                                </Text>

                                <Text medium>${ procedure.dentistFeeClaimed }</Text>
                            </div>

                            {
                                (procedure.labProcedureCode1 && procedure.labProcedureCode1.length > 0) &&
                                    <div style={styles.metaBlock}>
                                        <Text
                                            light
                                            medium
                                            flex={1}
                                        >
                                            Lab Code 1:
                                        </Text>

                                        <Text medium>{ procedure.labProcedureCode1 }</Text>
                                    </div>
                            }

                            {
                                (procedure.labProcedureFee1 && procedure.labProcedureFee1.length > 0) &&
                                    <div style={styles.metaBlock}>
                                        <Text
                                            light
                                            medium
                                            flex={1}
                                        >
                                            Lab Fee 1:
                                        </Text>

                                        <Text medium>${ procedure.labProcedureFee1 }</Text>
                                    </div>
                            }

                            {
                                (procedure.labProcedureCode2 && procedure.labProcedureCode2.length > 0) &&
                                    <div style={styles.metaBlock}>
                                        <Text
                                            light
                                            medium
                                            flex={1}
                                        >
                                            Lab Code 2:
                                        </Text>

                                        <Text medium>{ procedure.labProcedureCode2 }</Text>
                                    </div>
                            }

                            {
                                (procedure.labProcedureFee2 && procedure.labProcedureFee2.length > 0) &&
                                    <div style={styles.metaBlock}>
                                        <Text
                                            light
                                            medium
                                            flex={1}
                                        >
                                            Lab Fee 2:
                                        </Text>

                                        <Text medium>${ procedure.labProcedureFee2 }</Text>
                                    </div>
                            }

                            {
                                (procedure.typeCodes && procedure.typeCodes.length > 0) &&
                                    <div style={styles.metaBlock}>
                                        <Text
                                            light
                                            medium
                                            flex={1}
                                        >
                                            Type Codes:
                                        </Text>

                                        <Text medium>{ procedure.typeCodes }</Text>
                                    </div>
                            }

                            {
                                procedure.overrideAdjudication &&
                                        <>
                                            <div style={styles.metaBlock}>
                                                <Text
                                                    light
                                                    medium
                                                    flex={1}
                                                >
                                                    Dentist Fee Adjudicated Amount:
                                                </Text>

                                                <Text medium>${ procedure.dentistFeeAdjudicatedAmount }</Text>
                                            </div>

                                            {
                                                (procedure.dentistFeeDeductible && procedure.dentistFeeDeductible.length > 0) &&
                                                <div style={styles.metaBlock}>
                                                    <Text
                                                        light
                                                        medium
                                                        flex={1}
                                                    >
                                                        Dentist Fee Deductible:
                                                    </Text>

                                                    <Text medium>${ procedure.dentistFeeDeductible }</Text>
                                                </div>
                                            }

                                            {
                                                (procedure.labProcedureFee1AdjudicatedAmount && procedure.labProcedureFee1AdjudicatedAmount.length > 0) &&
                                                <div style={styles.metaBlock}>
                                                    <Text
                                                        light
                                                        medium
                                                        flex={1}
                                                    >
                                                        Lab Code 1 Adjudicated Amount:
                                                    </Text>

                                                    <Text medium>${ procedure.labProcedureFee1AdjudicatedAmount }</Text>
                                                </div>
                                            }

                                            {
                                                (procedure.labProcedureFee1DeductibleAmount && procedure.labProcedureFee1DeductibleAmount.length > 0) &&
                                                <div style={styles.metaBlock}>
                                                    <Text
                                                        light
                                                        medium
                                                        flex={1}
                                                    >
                                                        Lab Code 1 Deductible:
                                                    </Text>

                                                    <Text medium>${ procedure.labProcedureFee1DeductibleAmount }</Text>
                                                </div>
                                            }

                                            {
                                                (procedure.labProcedureFee2AdjudicatedAmount && procedure.labProcedureFee2AdjudicatedAmount.length > 0) &&
                                                <div style={styles.metaBlock}>
                                                    <Text
                                                        light
                                                        medium
                                                        flex={1}
                                                    >
                                                        Lab Code 2 Adjudicated Amount:
                                                    </Text>

                                                    <Text medium>${ procedure.labProcedureFee2AdjudicatedAmount }</Text>
                                                </div>
                                            }

                                            {
                                                (procedure.labProcedureFee2DeductibleAmount && procedure.labProcedureFee2DeductibleAmount.length > 0) &&
                                                <div style={styles.metaBlock}>
                                                    <Text
                                                        light
                                                        medium
                                                        flex={1}
                                                    >
                                                        Lab Code 2 Deductible:
                                                    </Text>

                                                    <Text medium>${ procedure.labProcedureFee2DeductibleAmount }</Text>
                                                </div>
                                            }
                                        </>
                            }
                        </div>
                    ))
                }

                {
                    this.props.extractedTeeth.map((extractedTooth, i) => (
                        <div style={{ margin: "10px 0" }} >
                            <Text bold medium color={ Theme.colors.skyBlue } margin="10px 0">
                                    Extracted Tooth { i + 1 }
                            </Text>

                            <div style={styles.metaBlock}>
                                <Text
                                    light
                                    medium
                                    flex={1}
                                >
                                        Tooth Number:
                                </Text>

                                <Text medium>{ extractedTooth.toothNumber }</Text>
                            </div>

                            {
                                (extractedTooth.extractionDate && extractedTooth.extractionDate.length > 0) &&
                                    <div style={styles.metaBlock}>
                                        <Text
                                            light
                                            medium
                                            flex={1}
                                        >
                                            Extraction Date:
                                        </Text>

                                        <Text medium>{ dates.getLocalDisplay(extractedTooth.extractionDate) }</Text>
                                    </div>
                            }
                        </div>
                    ))
                }

                {
                    this.props.receiptPhoto &&
                            <div style={styles.block}>
                                <Text
                                    bold
                                    medium
                                    customStyle={styles.flex}
                                    display="block"
                                >
                                    Receipt/Invoice:
                                </Text>

                                {
                                    this.props.receiptPhoto.file?.type === 'application/pdf' || this.props.receiptPhoto.contentType === 'application/pdf' ?
                                        <img alt="Receipt" src={ pdfImg } style={styles.receiptPhoto} />
                                        :
                                        <img alt="Receipt" src={ this.props.receiptPhoto.image || this.props.receiptPhoto.url } style={styles.receiptPhoto} />
                                }
                            </div>
                }

                <div style={styles.block}>
                    <Text
                        bold
                        medium
                        marginBottom={5}
                        customStyle={styles.flex}
                        display="block"
                    >
                            Supporting Documents:
                    </Text>

                    {
                        this.props.supportingPhotos && this.props.supportingPhotos.length > 0 ?
                            <PhotoGrid
                                photos={this.props.supportingPhotos}
                            />
                            :
                            <Text
                                light
                                small
                            >
                                    No supporting documents.
                            </Text>
                    }
                </div>

                <Text light tiny>
                    { `By submitting this ${ type } I agree to the Simply Benefits Terms of Service.` }
                </Text>
            </Modal>
        );
    }
}

export default connect()(ReviewClaimModal);